import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Tab } from 'react-bootstrap';

import TimePickerButtonGroup from './TimePickerButtonGroup';

export default class TimePickerTab extends Component {
  render() {
    let { eventKey, title, isSelected, data, zoneId } = this.props,
      view = null;

    if (isSelected) {
      view = (
        <Tab eventKey={eventKey} title={title}>
          <TimePickerButtonGroup onChange={this.handleRadioSelect.bind(this)} data={data} zoneId={zoneId} />
        </Tab>
      );
    }

    return view;
  }

  handleRadioSelect(selectedTime) {
    let { onChange } = this.props;

    onChange(selectedTime);
  }
}

TimePickerTab.propTypes = {
  eventKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  isSelected: PropTypes.bool,
  data: PropTypes.array,
  zoneId: PropTypes.string,
  onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TimePicker/TimePickerTab.js